import type { FC } from "react"

import { useCancelDesignRequest } from "~/containers/Proposal/state/design-request/use-design-request"
import { useProposalActions } from "~/containers/Proposal/state/proposal/proposal-context"
import type { Design } from "~/graphql/client"

import { ReactComponent as XIcon } from "@svg/x.svg"

import { Buttons, Header, Info, Wrapper } from "./styles"

export const Cancel: FC<{
  close: VoidFunction
  designRevision?: Design
  isCurrent: boolean
}> = ({ close, designRevision, isCurrent }) => {
  const { cancel, mutation } = useCancelDesignRequest()
  const { refetch } = useProposalActions()
  const handleConfirm = async () => {
    if (isCurrent) return
    if (!designRevision?.designRequest?.id) return
    await cancel(designRevision.designRequest.id)
    await refetch()
    close()
  }

  return (
    <Wrapper isSaving={mutation.isLoading}>
      <Header>
        <h1>Cancel Request</h1>
        <XIcon onClick={close} />
      </Header>
      {isCurrent && (
        <Info>
          <p
            style={{
              color: `var(--danger)`,
            }}
          >
            The active design cannot be cancelled. Please activate a different
            revision to cancel this one.
          </p>
        </Info>
      )}
      {!isCurrent && (
        <>
          <Info>
            <p>
              Are you sure you want to cancel this request? This action cannot be
              undone.
            </p>
          </Info>
          <Buttons>
            <button disabled={isCurrent} onClick={handleConfirm}>
              Cancel Request
            </button>
            <button onClick={close}>Nevermind</button>
          </Buttons>
        </>
      )}
    </Wrapper>
  )
}
